import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { LivePreviewService } from '../../shared/services/live-preview.service';
import { LeadGenerationStylesService } from '../../shared/services/lead-generation-styles.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import { Configuration } from '../../shared/domain/configuration.model';
import { getActiveProjectSelector } from '../../projects/projects.reducer';
import { IState } from '../../../shared/models/state';
import { Store } from '@ngrx/store';
import { UpdateProjectStyleAction } from '../../projects/projects.action';
import { MatDialog } from '@angular/material';
import { ConfirmDialogComponent } from '../../../shared/dialog/confirm-dialog/confirm-dialog.component';
import { markFormAsTouched } from '../../shared/reactive-forms/forEachElementInForm';

@Component({
  selector: 'cc-lg-bubble-creator',
  templateUrl: './bubble-creator.component.html',
  styleUrls: ['./bubble-creator.component.scss']
})
export class BubbleCreatorComponent implements OnInit {
  public popupSettings: FormGroup;
  public config: Configuration;

  constructor(
    private livePreviewService: LivePreviewService,
    private leadGenerationStylesService: LeadGenerationStylesService,
    private dialog: MatDialog,
    private amplitudeService: AmplitudeService,
    private store: Store<IState>
  ) {
    this.popupSettings = this.leadGenerationStylesService.createBubbleForm();
  }

  ngOnInit() {
    this.logAmplitude('Init');
    this.store.select(getActiveProjectSelector).subscribe((config: Configuration) => {
      this.config = config;
      this.leadGenerationStylesService.updateForm(this.popupSettings, this.config, 'bubble');
    });
    this.popupSettings.valueChanges.subscribe(() => this.sendChanges());
  }

  sendChanges() {
    this.livePreviewService.sendToFrame('CHANGE_SETTINGS', this.popupSettings.value, undefined);
  }

  get currentProjectId() {
    return this.config.projectId;
  }

  saveDb() {
    if (this.popupSettings.invalid) {
      this.logAmplitude('Invalid form', this.popupSettings.errors);
      markFormAsTouched(this.popupSettings);
      return;
    }
    this.logAmplitude('Confirming');

    this.dialog
      .open(ConfirmDialogComponent, {
        data: {
          title: 'LEAD_GENERATION.CONFIRMATION_TITLE',
          body: 'LEAD_GENERATION.CONFIRMATION_BUBBLE_INFO'
        }
      })
      .afterClosed()
      .subscribe(confirm => {
        if (confirm) {
          this.amplitudeService.logEvent('Panel: Lead Generation: Bubble Published');
          this.store.dispatch(
            new UpdateProjectStyleAction({
              type: 'BUBBLE',
              body: this.popupSettings.value,
              config: this.config
            })
          );
        }
      });
  }

  onChangeEditorCode(code, formField) {
    this.popupSettings.get(formField).setValue(code);
  }

  private logAmplitude(message: string, event?: any) {
    this.amplitudeService.logEvent(`Panel:WebCall:BubbleCreator: ${message}`, event);
  }
}
